import type { IconSvgObject } from './types';

const PlusMinusCircle02Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 16L16 8M7 9H9M9 9H11M9 9V7M9 9V11M13 15H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PlusMinusCircle02Icon;
